/** @format */

'use client';
import React from 'react';
import DialogContentView from './dialogContentView';
import { Dialog } from '@radix-ui/themes';

interface LayoutProps {
	enableFullWidthTrigger: boolean;
	headerContent: React.ReactNode | string;
	handleDialogViewChange: any;
	enableDialogView: boolean | null;
	triggerContent: React.ReactNode;
	content: React.ReactNode;
	enableCloseAction: boolean;
	contentClassValue: string;
	handleDialogCloseAction: () => void;
}

const DialogLayoutView: React.FC<LayoutProps> = (props) => (
	<Dialog.Root  {...props?.enableDialogView !== null ? { open: props?.enableDialogView, onOpenChange: props?.handleDialogViewChange } : {}}>
		<Dialog.Trigger><div className={'!flex hover:!cursor-pointer' + (props?.enableFullWidthTrigger ? ' w-full' : '')} aria-label={`Open ${props?.headerContent} dialog`}>{props?.triggerContent}</div></Dialog.Trigger>
		<DialogContentView
			handleAninamtionChange={() => {
			}}
			headerContent={props?.headerContent}
			handleDialogCloseAction={() => props?.handleDialogCloseAction()}
			enableCloseAction={props?.enableCloseAction}
			contentClassValue={props?.contentClassValue + ' !px-5 !pt-8 !pb-5'}
		>
			{props?.content}
		</DialogContentView>
	</Dialog.Root>
);

export default DialogLayoutView;
